var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-app",
    [
      _c(
        "v-form",
        {
          ref: "form",
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.submit.apply(null, arguments)
            },
          },
          model: {
            value: _vm.valid,
            callback: function ($$v) {
              _vm.valid = $$v
            },
            expression: "valid",
          },
        },
        [
          _c(
            "v-container",
            { attrs: { fluid: "" } },
            [
              _c("div", { staticClass: "mb-2 col-12" }, [
                _c("p", { staticClass: "tc-subtitle" }, [
                  _vm._v(
                    "Enhance your next lesson plan with a Teacher Collection of library materials to use in your classroom."
                  ),
                ]),
                _vm._v(" "),
                _c("p", [_vm._v("Here's how it works:")]),
                _vm._v(" "),
                _c("ul", [
                  _c("li", [
                    _c("p", [
                      _vm._v(
                        "Multiple copy requests are not guaranteed and will be filled based on availability of titles."
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("p", [
                      _vm._v(
                        "We need a minimum of 14 days' notice to fulfill your request."
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("p", [
                      _vm._v(
                        "A Teacher Collection can include a maximum of 30 print/audio items and five DVDs which can be on a specific subject, by a particular author or a general collection of fiction and nonfiction books."
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("p", [
                      _vm._v(
                        "Requests for seasonal books, curriculum-related books in high demand, and books by visiting authors may be limited due to availability."
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("p", [
                      _vm._v(
                        "A teacher can request a maximum of two Teacher Collections per month while not exceeding the library's borrowing limits."
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("p", [
                      _vm._v(
                        "You must be a certified K-12 school teacher, licensed childcare instructor or verified homeschool educator with a valid "
                      ),
                      _c(
                        "a",
                        { attrs: { href: _vm.cardUrl, target: "_blank" } },
                        [_vm._v("Educator Card")]
                      ),
                      _vm._v(
                        " from Columbus Metropolitan Library. Want to apply? Stop by any location."
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("p", [
                      _vm._v("Call 614-645-2275 for more information."),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("h2", { staticClass: "mb-6 pl-2" }, [_vm._v("Login")]),
              _vm._v(" "),
              _c("p", { staticClass: "mb-4 pl-2 help-block" }, [
                _c("strong", { staticClass: "asterix" }, [_vm._v("* ")]),
                _vm._v("indicates required field."),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "pl-4" },
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        {
                          staticClass:
                            "d-flex pl-0 pb-0 col-12 col-sm-6 col-md-4 col-lg-4",
                        },
                        [
                          [
                            _c("div", [
                              _c("h4", [
                                _c("strong", [_vm._v("Library Card")]),
                                _c("strong", { staticClass: "asterix" }, [
                                  _vm._v(" *"),
                                ]),
                              ]),
                            ]),
                          ],
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        {
                          staticClass:
                            "d-flex pl-0 pb-0 col-12 col-sm-6 col-md-4 col-lg-4",
                        },
                        [
                          _c("v-text-field", {
                            attrs: {
                              outlined: "",
                              label: "Library Card",
                              value: _vm.form.teacherCard,
                              rules: [_vm.rules.required, _vm.rules.card],
                              type: "text",
                            },
                            on: {
                              keypress: function ($event) {
                                return _vm.isNumber($event)
                              },
                            },
                            model: {
                              value: _vm.form.teacherCard,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "teacherCard", $$v)
                              },
                              expression: "form.teacherCard",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        {
                          staticClass:
                            "d-flex pl-0 pb-0 col-12 col-sm-6 col-md-4 col-lg-4",
                        },
                        [
                          [
                            _c("div", [
                              _c("h4", [
                                _c("strong", [_vm._v("PIN Number")]),
                                _c("strong", { staticClass: "asterix" }, [
                                  _vm._v(" *"),
                                ]),
                              ]),
                            ]),
                          ],
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        {
                          staticClass:
                            "d-flex pl-0 pb-0 col-12 col-sm-6 col-md-4 col-lg-4",
                        },
                        [
                          _c("v-text-field", {
                            attrs: {
                              outlined: "",
                              label: "PIN Number",
                              value: _vm.form.teacherPin,
                              rules: [_vm.rules.required, _vm.rules.pin],
                              type: _vm.show ? "text" : "password",
                              "append-icon": _vm.show
                                ? "mdi-eye"
                                : "mdi-eye-off",
                            },
                            on: {
                              keypress: function ($event) {
                                return _vm.isNumber($event)
                              },
                              "click:append": function ($event) {
                                _vm.show = !_vm.show
                              },
                            },
                            model: {
                              value: _vm.form.teacherPin,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "teacherPin", $$v)
                              },
                              expression: "form.teacherPin",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "tc-button submit-btn",
                  attrs: { type: "submit" },
                },
                [_vm._v("Submit")]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "ml-4 tc-button",
                  on: {
                    click: function ($event) {
                      return _vm.cancel()
                    },
                  },
                },
                [
                  _c("v-icon", { staticClass: "pr-1" }, [
                    _vm._v("mdi-close-thick"),
                  ]),
                  _vm._v("Cancel\n      "),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }